<template>
  <el-card id="product-card">
    <el-table :data="tableData" border style="margin: 0 auto;">
      <el-table-column prop="fundName" label="产品名称" width="190">
      </el-table-column>
      <el-table-column prop="fundCode" label="基金代码"> </el-table-column>
      <el-table-column prop="fundType" label="产品类型"> </el-table-column>
      <el-table-column prop="fundDelegator" label="托管人"> </el-table-column>
      <el-table-column prop="fundInitialBuying" label="认购起点">
      </el-table-column>
      <el-table-column prop="fundFurtherBuying" label="追加认购">
      </el-table-column>
      <el-table-column prop="fundAdministrationInterest" label="管理费率">
      </el-table-column>
      <el-table-column prop="fundBuyingInterest" label="认/申购费率">
      </el-table-column>
      <el-table-column prop="fundClosingPeriod" label="封闭期">
      </el-table-column>
      <el-table-column prop="fundOpenDay" label="开放日"> </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          fundName: "华银德洋基金",
          fundCode: "S26669",
          fundType: "股票类",
          fundDelegator: "招商证券",
          fundInitialBuying: "100万",
          fundFurtherBuying: "10万",
          fundAdministrationInterest: "无",
          fundBuyingInterest: "1%",
          fundClosingPeriod: "6个月",
          fundOpenDay: "每月20日"
        },
        {
          fundName: "华银共同基金",
          fundCode: "S20888",
          fundType: "股票类",
          fundDelegator: "招商证券",
          fundInitialBuying: "100万",
          fundFurtherBuying: "10万",
          fundAdministrationInterest: "2%",
          fundBuyingInterest: "1%",
          fundClosingPeriod: "6个月",
          fundOpenDay: "每月20日"
        },
        {
          fundName: "共同成长基金",
          fundCode: "S34888",
          fundType: "股票类",
          fundDelegator: "招商证券",
          fundInitialBuying: "100万",
          fundFurtherBuying: "10万",
          fundAdministrationInterest: "1%",
          fundBuyingInterest: "1%",
          fundClosingPeriod: "6个月",
          fundOpenDay: "每月20日"
        },
        {
          fundName: "紫华私募基金",
          fundCode: "SCU769",
          fundType: "股票类",
          fundDelegator: "招商证券",
          fundInitialBuying: "100万",
          fundFurtherBuying: "10万",
          fundAdministrationInterest: "2%",
          fundBuyingInterest: "1%",
          fundClosingPeriod: "6个月",
          fundOpenDay: "每月20日"
        },
        {
          fundName: "伟强一号私募基金",
          fundCode: "SCS503",
          fundType: "股票类",
          fundDelegator: "招商证券",
          fundInitialBuying: "100万",
          fundFurtherBuying: "10万",
          fundAdministrationInterest: "2%",
          fundBuyingInterest: "1%",
          fundClosingPeriod: "6个月",
          fundOpenDay: "每月20日"
        },
        {
          fundName: "华银领先十六期基金",
          fundCode: "S36986",
          fundType: "股票类",
          fundDelegator: "招商证券",
          fundInitialBuying: "100万",
          fundFurtherBuying: "10万",
          fundAdministrationInterest: "1%",
          fundBuyingInterest: "1%",
          fundClosingPeriod: "6个月",
          fundOpenDay: "每月20日"
        },
        {
          fundName: "嘉禾三号私募证券投资基金",
          fundCode: "SM7066",
          fundType: "股票类",
          fundDelegator: "国泰君安",
          fundInitialBuying: "100万",
          fundFurtherBuying: "10万",
          fundAdministrationInterest: "0.5%",
          fundBuyingInterest: "无",
          fundClosingPeriod: "6个月",
          fundOpenDay: "每月20日"
        },
        {
          fundName: "共同富裕私募证券投资基金",
          fundCode: "SST197",
          fundType: "股票类",
          fundDelegator: "招商证券",
          fundInitialBuying: "100万",
          fundFurtherBuying: "10万",
          fundAdministrationInterest: "2%",
          fundBuyingInterest: "1%",
          fundClosingPeriod: "6个月",
          fundOpenDay: "每月20日"
        },
        {
          fundName: "共同元宇宙私募证券投资基金",
          fundCode: "SSV450",
          fundType: "股票类",
          fundDelegator: "招商证券",
          fundInitialBuying: "100万",
          fundFurtherBuying: "10万",
          fundAdministrationInterest: "2%",
          fundBuyingInterest: "1%",
          fundClosingPeriod: "6个月",
          fundOpenDay: "每月20日"
        },
        {
          fundName: "共同医疗科创私募证券投资基金",
          fundCode: "SJV076",
          fundType: "股票类",
          fundDelegator: "招商证券",
          fundInitialBuying: "100万",
          fundFurtherBuying: "10万",
          fundAdministrationInterest: "1%",
          fundBuyingInterest: "1%",
          fundClosingPeriod: "6个月",
          fundOpenDay: "每月20日"
        },
        {
          fundName: "共同医药成长私募证券投资基金",
          fundCode: "SJR590",
          fundType: "股票类",
          fundDelegator: "招商证券",
          fundInitialBuying: "100万",
          fundFurtherBuying: "10万",
          fundAdministrationInterest: "1%",
          fundBuyingInterest: "1%",
          fundClosingPeriod: "6个月",
          fundOpenDay: "每月20日"
        },
        {
          fundName: "共同大健康量化私募证券投资基金",
          fundCode: "SJR648",
          fundType: "股票类",
          fundDelegator: "招商证券",
          fundInitialBuying: "100万",
          fundFurtherBuying: "10万",
          fundAdministrationInterest: "无",
          fundBuyingInterest: "1%",
          fundClosingPeriod: "6个月",
          fundOpenDay: "每月20日"
        }
      ]
    };
  }
};
</script>

<style scoped>
#product-card {
  margin: 0 auto;
  margin-top: 1%;
  width: 80%;
  margin-bottom: 20px;
  height: 100%;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/productTable.vue